import {Component, inject, Input, input} from '@angular/core';
import {Location} from "@angular/common";

@Component({
  selector: 'app-portal-title-bar',
  templateUrl: './portal-title-bar.component.html',
  styleUrl: './portal-title-bar.component.scss'
})
export class PortalTitleBarComponent {

  location = inject(Location);
  @Input() title: string;
  @Input() toHome: boolean;
  @Input() hideBackButton: boolean;

  goBack() {
    if (!this.toHome) {
      this.location.back()
    } else {
      location.href = '/home'
    }
  }

}

